// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import FitReportController from "./fit_report_controller"
application.register("fit-report", FitReportController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LekaloShowController from "./lekalo_show_controller"
application.register("lekalo-show", LekaloShowController)

import LekaloSizeController from "./lekalo_size_controller"
application.register("lekalo-size", LekaloSizeController)

import LekalosController from "./lekalos_controller"
application.register("lekalos", LekalosController)

import MannequinController from "./mannequin_controller"
application.register("mannequin", MannequinController)

import MaterialPickerController from "./material_picker_controller"
application.register("material-picker", MaterialPickerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestingConsoleController from "./nesting_console_controller"
application.register("nesting-console", NestingConsoleController)

import NewDesignModalController from "./new_design_modal_controller"
application.register("new-design-modal", NewDesignModalController)

import OrderChatController from "./order_chat_controller"
application.register("order-chat", OrderChatController)

import OrderCompositionController from "./order_composition_controller"
application.register("order-composition", OrderCompositionController)

import PieceGroupsController from "./piece_groups_controller"
application.register("piece-groups", PieceGroupsController)

import RecipientsController from "./recipients_controller"
application.register("recipients", RecipientsController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)
